// Numer telefonu = login do aplikacji Staff (Firebase `signInWithPhoneNumber`, SMS OTP).
// Firebase dopasuje ISTNIEJĄCE konto tylko gdy `phoneNumber` w Auth jest DOKŁADNIE tym
// samym stringiem E.164, co wysyła appka — inaczej zakłada NOWE konto (inny uid, bez
// organizacji i claimów). Dlatego wysyłamy numer już w E.164 (bez spacji/myślników).
//
// Logika lustrzana do `staff/.../SignInPhone.tsx`, panel-app (`utils/normalizePhone`)
// i backendu (`@hotelspot/functions-shared` → normalizePhoneE164).

const DEFAULT_DIAL_CODE = '+48';

/**
 * "512 345 678" | "512-345-678" | "0512345678" | "0048512345678" → "+48512345678".
 * Pusty input → ''.
 */
export const normalizePhoneE164 = (phone?: string, defaultDialCode = DEFAULT_DIAL_CODE): string => {
  const compact = (phone || '').replace(/[^\d+]/g, '');
  if (!compact) return '';

  let candidate = compact;
  if (candidate.startsWith('00')) candidate = `+${candidate.slice(2)}`;
  if (!candidate.startsWith('+')) {
    candidate = candidate.startsWith('0')
      ? `${defaultDialCode}${candidate.slice(1)}`
      : `${defaultDialCode}${candidate}`;
  }
  return candidate;
};

/** Poprawny E.164 — Firebase Auth odrzuca inne (`auth/invalid-phone-number`). */
export const isValidE164 = (value: string): boolean => /^\+[1-9]\d{7,14}$/.test(value);
